import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'

const ExerciseRepository = RepositoryFactory.get('exercise')

class ExerciseService {
  static async getExercises (lessonId, params) {
    try {
      return await ExerciseRepository.getExercises(lessonId, params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default ExerciseService
